/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Overall summary of the energy efficiency of the property feature. The values are defined as: - \"0\": N/A  - \"1\": Very Poor  - \"2\": Poor  - \"3\": Average  - \"4\": Good  - \"5\": Very Good 
 */
export type EnergyEfficiencySummaryCodeUIDTOV0 = '0' | '1' | '2' | '3' | '4' | '5';

export const EnergyEfficiencySummaryCodeUIDTOV0 = {
    _0: '0' as EnergyEfficiencySummaryCodeUIDTOV0,
    _1: '1' as EnergyEfficiencySummaryCodeUIDTOV0,
    _2: '2' as EnergyEfficiencySummaryCodeUIDTOV0,
    _3: '3' as EnergyEfficiencySummaryCodeUIDTOV0,
    _4: '4' as EnergyEfficiencySummaryCodeUIDTOV0,
    _5: '5' as EnergyEfficiencySummaryCodeUIDTOV0
};

